!<template>
  <div class="table-pagination">
    <b-pagination
      :value="$store.getters.page"
      @change="updatePage($event)"
      :per-page="$store.getters.perPage"
      :total-rows="$store.getters.totalListItems"
      limit="3"
      first-text="第一頁"
      last-text="最後一頁"
      variant="dark"
      size="sm"
    >
    </b-pagination>
  </div>
</template>

<script>
export default {
  methods: {
    updatePage(page) {
      this.$store.commit("page", page);
      // 當頁數更新時，父層要在 @updatePage 做什麼事情
      this.$emit("updatePage");
    }
  }
};
</script>

<style lang="scss" scoped>
.table-pagination {
  ::v-deep .b-pagination {
    justify-content: flex-end;
  }
}
</style>
